$(function() {

	$.nette.ext('jsTabs', {
		init: function() {
			this.init();
		},
		success: function() {
			this.init();
		}
	}, {
		init: function() {

			$('.js-tabs')
				.filter(function() {
					return ! $(this).not('#search-results').data('initialized');
				})
				.each(function() {
					var $this = $(this);
					var $tabs =  $this.find('.tab');
					var $tabsNav = $('<ul class="reset tabs-nav"></ul>');
					var $tabsNavExt = $('#tabs-ext-nav').find('a');

					$this.data('initialized', true);

					$tabs.each(function(i) {
						var title = $(this).data('tab-title') || $(this).find('.tab-title').text() || 'Tab ' + i;
						var id = $(this).attr('id');

						if (id) {
							$tabsNav.append('<li class="' + id + '"><a href="#' + id +'"><span>' + title + '</span></a></li>');
						}
					});

					if ($this.find('.tabs-nav').length)
						$this.find('.tabs-nav').replaceWith($tabsNav);
					else
						$this.prepend($tabsNav);

					$tabs
						.on('expanded.collapsable', function(e) {
							$(this).removeClass('tab-mob-closed');

							if (e.collapsableEvent.type === 'init.collapsable') {
								return;
							}

							if($(window).width() < 768 && ! $(this).closest('.pdbox__window').length)
								$(document).scrollTop($(this).offset().top);
						})
						.collapsable({
							control: '.tab-title',
							box: '.tab-box',
							classNames: {
								expanded: 'ca-tab-expanded',
								collapsed: 'ca-tab-collapsed',
								defaultExpanded: 'ca-tab-default-expanded',
								extLinkActive: 'ca-tab-ext-active'
							},
							accordion: true,
							collapsableAll: false,
							extLinks: {
								selector: $tabsNav.find('a').add($tabsNavExt),
								preventDefault: true
							}
						});
				});

		}
	});

});
